import { Card, Flex } from "@chakra-ui/react";
import { UserRolesTable } from "../UserRolesTable";
import { AppColors } from "@/styles/colors";

interface Props {
  userRoles?: { id: number; nombre: string }[];
  roleSelection: number[];
  setRoleSelection: (value: number[]) => void;
}

export const UserRolesCard = ({
  roleSelection,
  setRoleSelection,
  userRoles,
}: Props) => {
  return (
    <Card.Root maxW="full" marginTop="10px">
      <Card.Body
        paddingX="48px"
        paddingY="20px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            height: "240px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            height: "300px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            height: "380px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            height: "435px",
          },
          "@media (max-width: 1900px)": {
            height: "490px",
          },
          "@media (min-width: 1901px)": {
            height: "490px",
          },
        }}
      >
        <Flex
          flexDir="column"
          gap="30px"
          css={{
            "@media (max-width: 1350px) and (min-width: 1272px)": {
              height: "240px",
            },
            "@media (max-width: 1414px) and (min-width: 1351px)": {
              height: "300px",
            },
            "@media (max-width: 1590px) and (min-width: 1415px)": {
              height: "380px",
            },
            "@media (max-width: 1696px) and (min-width: 1591px)": {
              height: "435px",
            },
            "@media (max-width: 1900px)": {
              height: "490px",
            },
            "@media (min-width: 1901px)": {
              height: "490px",
            },
          }}
        >
          <UserRolesTable
            roleSelection={roleSelection || []}
            setRoleSelection={setRoleSelection}
            userRoles={userRoles}
          />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
